import { parseLatLon } from '~utils/address';

export const onSetStore = (state, action) =>
  state.merge({
    [action.target]: { ...action.payload, ...parseLatLon(action.payload) }
  });
